<template>
  <router-link
    :to="$buildContentLink('course', course)"
    class="course-history__course"
  >
    <p class="course-history__name">{{ course.name }}</p>
    <div class="course-history__statistics-container">
      <div class="course-history__progress-container">
        <div class="course-history__progress">
          <div class="course-history__progress-label">
            {{ getProgress(course.user_status.progress) }}%
          </div>
          <div
            class="dashboard__progress-wrapper course-history__progress-wrapper"
          >
            <div
              class="dashboard__progress-bar"
              :style="`width: ${getProgress(course.user_status.progress)}%`"
            ></div>
          </div>
        </div>
        <PlayIcon
          class="dashboard__action-icon dashboard__icon--play course-history__icon course-history__icon--mobile"
        />
      </div>
      <div
        v-if="getTimeInDaysAgo"
        class="dashboard__badge course-history__badge"
      >
        {{ getTimeInDaysAgo }}
      </div>
    </div>
    <PlayIcon
      class="dashboard__action-icon dashboard__icon--play course-history__icon"
    />
  </router-link>
</template>

<script>
import { formatDistance } from 'date-fns'
import { PlayIcon } from 'vue-feather-icons'

export default {
  name: 'CourseHistoryTile',
  components: {
    PlayIcon,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getTimeInDaysAgo() {
      const time = this.course?.user_status?.last_activity_date ?? ''
      return time && time !== 'None'
        ? `${formatDistance(new Date(), new Date(time))} ago`
        : ''
    },
  },
  methods: {
    getProgress(value) {
      return value === 1 ? 100 : Math.floor(value * 100)
    },
  },
}
</script>

<style lang="scss" scoped>
.course-history {
  &__course {
    display: flex;
    min-height: 56px;
    flex-wrap: nowrap;
    background: var(--glass-mid-gray);
    margin: 5px 0;
    padding: 8px 15px;
    text-decoration: none;
    border-radius: 5px;
    cursor: pointer;
    flex-direction: column;
    &:hover {
      opacity: 0.8;
    }
    @include mobile {
      flex-direction: row;
      align-items: center;
    }
  }
  &__name {
    color: var(--white);
    font-size: rem(14);
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    margin-bottom: 10px;
    text-overflow: ellipsis;
    @include mobile {
      flex: 0 1 400px;
      margin: 0;
      max-width: 400px;
    }
  }
  &__statistics-container {
    display: flex;
    flex-direction: column-reverse;
    @include mobile {
      flex-direction: row;
      flex: 1 0 45%;
    }
  }
  &__progress-wrapper {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }
  &__progress-container {
    display: flex;
    align-items: center;
    @include mobile {
      margin-right: 20px;
      max-width: 151px;
      flex: 0 0 151px;
    }
  }
  &__progress {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    @include mobile {
      margin-left: 20px;
    }
  }
  &__progress-label {
    font-size: rem(12);
    line-height: 14px;
    color: var(--positive-light);
  }
  &__badge {
    flex: 0;
    margin-bottom: 10px;
    @include mobile {
      margin-left: auto;
    }
  }
  &__icon {
    display: none;
    width: 40px;
    @include mobile {
      display: flex;
      flex: 0 0 42px;
      margin-left: 20px !important;
    }
    &--mobile {
      display: flex;
      margin-left: 20px !important;
      @include mobile {
        display: none;
      }
    }
  }
  &__error-msg {
    color: var(--white);
  }
}
</style>
